import React from 'react';
import check from '@/public/svg/check.svg';

interface TextImageSectionProps {
    title: string;
    text?: string;
    list?: string[];
    imageUrl: string;
    imageAlt?: string;
    imageLeft?: boolean;
    bgColor?: 'white' | 'sand';
    actions?: React.ReactNode;
}

const TextImage: React.FC<TextImageSectionProps> = ({
    title,
    text,
    list,
    imageUrl,
    imageAlt = '',
    imageLeft = false,
    bgColor = 'white',
    actions,
}) => {

    const bgClass = bgColor === 'sand' ? 'bg-productCard' : 'bg-white';

    return (
        <section className={`w-full py-12 px-4 ${bgClass}`}>
            <div className={`flex flex-col lg:flex-row ${imageLeft ? 'lg:flex-row-reverse' : ''} items-center gap-8 max-w-6xl mx-auto`}>
                <div className="lg:w-1/2">
                    <img
                        src={imageUrl}
                        alt={imageAlt}
                        loading="lazy"
                        className="w-full max-h-[450px] rounded-xl shadow-md object-cover"
                    />
                </div>
                <div className="lg:w-1/2 text-center lg:text-left">
                    <h2 className="text-3xl font-bold text-textColor mb-4">{title}</h2>
                    {list && list.length > 0 ? (
                        <ul className="list-disc list-inside text-gray-700 text-lg text-left space-y-2">
                            {list.map((item, idx) => (
                                <li key={idx} className="flex items-start gap-3">
                                    <img src={check} alt="" loading="lazy" className="h-8 w-8 flex-shrink-0" />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        text && <p className="text-gray-700 text-lg" dangerouslySetInnerHTML={{ __html: text }}></p>
                    )}
                    {actions && <div className="mt-6 flex flex-wrap justify-center lg:justify-start gap-3">{actions}</div>}
                </div>
            </div>
        </section>
    );
};

export default TextImage;
